// svg
svg4everybody();

//
$(document).ready(function () {
  const brkpnt = 768;

  // SLIDEDOWN
  $(document).on('click', '.js_slidedown_trigger', function (e) {
    let slideTarget = '';
    if ($(this).attr('data-target')) {
      slideTarget = $(this).attr('data-target');
    } else {
      slideTarget = $(this)
        .closest('.js_slidedown')
        .toggleClass('active')
        .find('.js_slidedown_content');
    }
    $(this).toggleClass('active');
    $(slideTarget).stop().slideToggle(300);

    e.preventDefault();
  });

  $(document).on('focus', '.flipper__link', function (e) {
    $(this).closest('.flipper').addClass('focused');
  });
  $(document).on('blur', '.flipper__link', function (e) {
    $(this).closest('.flipper').removeClass('focused');
  });

  const swiper = new Swiper('.js_swiper_flippers', {
    loop: false,
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    mousewheel: true,
    watchOverflow: true,
    // freeModeMomentum: false,
    freeModeMomentumRatio: 0.3,

    breakpoints: {
      brkpnt: {
        spaceBetween: 10,
      },
    },
  });

  function pillVisible() {
    $('.headerpill').each(function () {
      if ($(this).visible(false, false, 'vertical')) {
        $(this).addClass('visible');
      } else {
        // $(this).removeClass('visible');
      }
    });
  }

  pillVisible();
  $(window).scroll(function () {
    // clearTimeout(window.scrollFinished);
    // window.scrollFinished = setTimeout(function () {
    pillVisible();
    // }, 100);
  });

  // SCROLL TO
  function scrollTo(target, correction, speed) {
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $(target).offset().top - correction,
        },
        speed
      );
  }

  $(document).on('click', '.js_scrollto', function (e) {
    $(this).blur();
    scrollTo($(this).attr('href'), 100, 500);

    e.preventDefault();
  });

  // SCROLL TO TOP
  $(document).on('click', '.js_tothetop', function (e) {
    scrollTo($('body'), 0, 700);

    e.preventDefault();
  });

  // COUNTDOWN

  $.ajax({
    type: 'GET',
    cache: false,
    url: location.href,
    complete: function (req, textStatus) {
      var dateString = req.getResponseHeader('Date');
      if (dateString.indexOf('GMT') === -1) {
        dateString += ' GMT';
      }

      var sDate = new Date(dateString);

      setTimer(sDate);
    },
  });

  function setTimer(today) {
    console.log(today);

    //date_default_timezone_set('Etc/GMT+3');
    //var target_date = new Date().getTime() + (1000*3600*48); // установить дату обратного отсчета
    var target_date = new Date(2021, 5, 15, 17, 0, 0);
    // today = new Date(<? echo date('Y,n - 1,j,H,i,s') ?>);

    var days, hours, minutes, seconds;
    var dayWord, hourWord, minWord, secWord;
    var dayWords, hourWords, minWords, secWords;

    var words;

    var countdown = document.getElementById('js_countdown');

    var current_date = today.getTime();

    // function checkMedia() {
    //   if (window.matchMedia('(min-width: 768px)').matches) {
    //     (dayWords = ['День', 'Дня', 'Дней']),
    //       (hourWords = ['Час', 'Часа', 'Часов']),
    //       (minWords = ['Минута', 'Минуты', 'Минут']),
    //       (secWords = ['Секунда', 'Секунды', 'Секунд']);
    //   } else {
    //     (dayWords = ['Дн', 'Дн', 'Дн']),
    //       (hourWords = ['Ч', 'Ч', 'Ч']),
    //       (minWords = ['Мин', 'Мин', 'Мин']),
    //       (secWords = ['Сек', 'Сек', 'Сек']);
    //   }
    // }
    // checkMedia();
    // window.onresize = function (event) {
    //   checkMedia();
    // };

    (dayWords = ['День', 'Дня', 'Дней']),
      (hourWords = ['Час', 'Часа', 'Часов']),
      (minWords = ['Минута', 'Минуты', 'Минут']),
      (secWords = ['Секунда', 'Секунды', 'Секунд']);

    if (today < target_date) {
      $('#js_countdown_wrapper').css({ opacity: '1' });

      getCountdown();

      var refreshInterval = setInterval(function () {
        getCountdown();
      }, 1000);
    } else if (today >= target_date) {
      // countdown.remove();
      $('#js_countdown_wrapper').css({ opacity: '1' });
    }

    function getCountdown() {
      current_date = current_date + 1000;
      var seconds_left = (target_date - current_date) / 1000;

      days = parseInt(seconds_left / 86400);
      seconds_left = seconds_left % 86400;

      hours = pad(parseInt(seconds_left / 3600));
      seconds_left = seconds_left % 3600;

      minutes = pad(parseInt(seconds_left / 60));
      seconds = pad(parseInt(seconds_left % 60));

      // dayWord = words(days, dayWords);
      // hourWord = words(hours, hourWords);
      // minWord = words(minutes, minWords);
      // secWord = words(seconds, secWords);

      dayWord = dayWords[2];
      hourWord = hourWords[2];
      minWord = minWords[2];
      secWord = secWords[2];

      countdown.innerHTML =
        '<div class="cnd__holder">\
                  <span class="cnd__tile">' +
        days +
        '</span>\
                  <span class="cnd__label">' +
        dayWord +
        '</span>\
                </div>\
                <div class="cnd__holder">\
                  <span class="cnd__tile">' +
        hours +
        '</span>\
                  <span class="cnd__label">' +
        hourWord +
        '</span>\
                </div>\
                <div class="cnd__holder">\
                  <span class="cnd__tile">' +
        minutes +
        '</span>\
                  <span class="cnd__label">' +
        minWord +
        '</span>\
                </div>\
                <div class="cnd__holder">\
                  <span class="cnd__tile">' +
        seconds +
        '</span>\
                  <span class="cnd__label">' +
        secWord +
        '</span>\
                </div>';

      if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
        clearInterval(refreshInterval);
      }
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function words(x, thisWords) {
      if ((11 <= x && x <= 14) || (-14 <= x && x <= -11)) {
        return thisWords[2];
      } else {
        var lastDigit = x.toString().slice(-1);

        if (lastDigit == 1) {
          return thisWords[0];
        } else if (2 <= lastDigit && lastDigit <= 4) {
          return thisWords[1];
        } else {
          return thisWords[2];
        }
      }
    }
  }

  $(document).on('click', '.tabs__label', function () {
    const scrollParent = $(this).closest('.tabs__select'),
      thisPos = $(this).offset().left,
      thisWidth = $(this).innerWidth(),
      currentNavScroll = scrollParent.scrollLeft();
    scrollParent
      .stop()
      .animate({ scrollLeft: currentNavScroll + thisPos - thisWidth / 2 }, 300, 'linear');
  });
});
